export default class ClientGroupModel {
  nomeGrupo!: string;

  codGrupo!: string;
}
